export const COMPANY_COLLECTION = "companies";
export const USER_COLLECTION = "users";
export const NEWS_COLLECTION = "news";
export const SURVEY_COLLECTION = "surveys";
export const QUESTION_COLLECTION = "questions";
export const STATIC_COLLECTION = "static";
export const ANSWER_COLLECTION = "answers";
export const FETCH_LIMIT = 5;
